import "./tree.css";
import React, { useState } from "react";
import useTree from "../../../../../hooks/corral/tree";
import { useCurrentUser } from "../../../../../hooks/currentUser";
import QuadrantBubble from "../QuadrantBubble";
import Rotation from "./Rotation";
import TreeAbilities from "../ability/TreeAbilities";
import {
  Center,
  Loader,
  Overlay,
  Container,
  Title,
  Group,
  Button,
  Anchor,
  Card,
  Text,
} from "@mantine/core";
import { useParams, useNavigate } from "react-router";
import { faTrash, faTable } from "../../../../../util/FontAwesomeIcons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const Tree = () => {
  const [showAbilities, setShowAbilities] = useState(false);
  const navigate = useNavigate();
  const { treeId } = useParams();
  const { currentUser } = useCurrentUser();
  const { tree, treeRef, dimensions, loading, glyphSlots, respecTree } =
    useTree({
      currentUser,
      treeId,
    });

  if (loading) {
    return (
      <Overlay opacity={0.6} color="#000" zIndex={5}>
        <Loader size="xl" variant="bars" />
      </Overlay>
    );
  }

  return (
    <Container>
      <Center>
        <Title order={3}>{tree.name} Attuned Planar Tree</Title>
      </Center>
      {tree.terminusActive && (
        <Center>
          <Card
            shadow="sm"
            padding="md"
            radius="md"
            my="sm"
            withBorder
            style={{ backgroundColor: "#fff3cd" }}
          >
            <Anchor onClick={() => navigate("/campaigns/corral/arboretum")}>
              New Trees are Now Available. Check Them Out in Your Arboretum
            </Anchor>
          </Card>
        </Center>
      )}
      {glyphSlots?.length > 0 && (
        <Group justify="right">
          <Button
            leftSection={<FontAwesomeIcon icon={faTable} />}
            onClick={() => setShowAbilities(!showAbilities)}
          >
            {showAbilities ? "Show Tree" : "Show Abilities"}
          </Button>
          <Button
            leftSection={<FontAwesomeIcon icon={faTrash} />}
            onClick={respecTree}
          >
            Respec
          </Button>
        </Group>
      )}
      <Center>
        {showAbilities && glyphSlots?.length > 0 ? (
          <TreeAbilities treeId={tree.id} glyphs={glyphSlots} maxHeight={787} />
        ) : (
          <div className="tree-card" ref={treeRef}>
            {tree.quadrants?.map((quadrant) => (
              <QuadrantBubble
                key={quadrant.id}
                dimensions={dimensions}
                graphObj={tree}
                onClick={() => {
                  if (quadrant.id === "source") {
                    navigate(`seed/${quadrant.id}`);
                  } else {
                    navigate(`constellation/${quadrant.id}`);
                  }
                }}
                {...quadrant}
              />
            ))}
            <Rotation
              direction={tree.direction}
              dimensions={dimensions}
              active={tree.terminusActive}
            />
          </div>
        )}
      </Center>
    </Container>
  );
};

export default Tree;
